export interface LayerUiModel {
    id: number;
    profile: string;
    url: string;
    img: string
}

export class Layers {
    public static get(): Array<LayerUiModel> {
        return [
            {
                id: 1,
                url: 'assets/marker/1J61d5Iqa8WmiUtm.png',
                img: '1J61d5Iqa8WmiUtm',
                profile: '1J61d5Iqa8WmiUtm',
            },
            {
                id: 2,
                url: 'assets/marker/3ujN0KsrsWdkRmjf.png',
                img: '3ujN0KsrsWdkRmjf',
                profile: '3ujN0KsrsWdkRmjf',
            },
            {
                id: 3,
                url: 'assets/marker/3wKnED5nsC0JWSb0.png',
                img: '3wKnED5nsC0JWSb0',
                profile: '3wKnED5nsC0JWSb0',
            },
            {
                id: 4,
                url: 'assets/marker/4DNUlDUsczkjjbYX.png',
                img: '4DNUlDUsczkjjbYX',
                profile: '4DNUlDUsczkjjbYX',
            },
            {
                id: 5,
                url: 'assets/marker/5z8N1nNTFwJJDPAu.png',
                img: '5z8N1nNTFwJJDPAu',
                profile: '5z8N1nNTFwJJDPAu',
            },
            {
                id: 6,
                url: 'assets/marker/9HXYoZW3dmtpSaRK.png',
                img: '9HXYoZW3dmtpSaRK',
                profile: '9HXYoZW3dmtpSaRK',
            },
            {
                id: 7,
                url: 'assets/marker/9LY7IQt9shBnDnI2.png',
                img: '9LY7IQt9shBnDnI2',
                profile: '9LY7IQt9shBnDnI2',
            },
            {
                id: 8,
                url: 'assets/marker/97VkcyamcCwiqvtj.png',
                img: '97VkcyamcCwiqvtj',
                profile: '97VkcyamcCwiqvtj',
            },
            {
                id: 9,
                url: 'assets/marker/ApDFKuYLbp9A1MS7.png',
                img: 'ApDFKuYLbp9A1MS7',
                profile: 'ApDFKuYLbp9A1MS7',
            },
            {
                id: 10,
                url: 'assets/marker/bwANPRwmCDfLlflz.png',
                img: 'bwANPRwmCDfLlflz',
                profile: 'bwANPRwmCDfLlflz',
            },
            {
                id: 11,
                url: 'assets/marker/EKuTr74XkbRuTzIa.png',
                img: 'EKuTr74XkbRuTzIa',
                profile: 'EKuTr74XkbRuTzIa',
            },
            {
                id: 12,
                url: 'assets/marker/HxHGC8hvD99Q9JHC.png',
                img: 'HxHGC8hvD99Q9JHC',
                profile: 'HxHGC8hvD99Q9JHC',
            },
            {
                id: 13,
                url: 'assets/marker/HZt5X7t0DtjgY6Rf.png',
                img: 'HZt5X7t0DtjgY6Rf',
                profile: 'HZt5X7t0DtjgY6Rf',
            },
            {
                id: 14,
                url: 'assets/marker/JhEKkRMHIszcbH0R.png',
                img: 'JhEKkRMHIszcbH0R',
                profile: 'JhEKkRMHIszcbH0R',
            },
            {
                id: 15,
                url: 'assets/marker/KfSbENjBCisDix5z.png',
                img: 'KfSbENjBCisDix5z',
                profile: 'KfSbENjBCisDix5z',
            },
            {
                id: 16,
                url: 'assets/marker/kHhTGh2bk3zYDD46.png',
                img: 'kHhTGh2bk3zYDD46',
                profile: 'kHhTGh2bk3zYDD46',
            },
            {
                id: 17,
                url: 'assets/marker/lQU4Xyyg9EOa4W0l.png',
                img: 'lQU4Xyyg9EOa4W0l',
                profile: 'lQU4Xyyg9EOa4W0l',
            },
            {
                id: 18,
                url: 'assets/marker/m6fI2ug2mW2iN9XS.png',
                img: 'm6fI2ug2mW2iN9XS',
                profile: 'm6fI2ug2mW2iN9XS',
            },
            {
                id: 19,
                url: 'assets/marker/mELXfjtNcUWxrmjx.png',
                img: 'mELXfjtNcUWxrmjx',
                profile: 'mELXfjtNcUWxrmjx',
            },
            {
                id: 20,
                url: 'assets/marker/nZVn5NHY5OANAXTn.png',
                img: 'nZVn5NHY5OANAXTn',
                profile: 'nZVn5NHY5OANAXTn',
            },
            {
                id: 21,
                url: 'assets/marker/O6IYyZF17jk7bQzz.png',
                img: 'O6IYyZF17jk7bQzz',
                profile: 'O6IYyZF17jk7bQzz',
            },
            {
                id: 22,
                url: 'assets/marker/OhNZTDAsVY5ZcLhk.png',
                img: 'OhNZTDAsVY5ZcLhk',
                profile: 'OhNZTDAsVY5ZcLhk',
            },
            {
                id: 23,
                url: 'assets/marker/sk8rFrNE68Bx3zhM.png',
                img: 'sk8rFrNE68Bx3zhM',
                profile: 'sk8rFrNE68Bx3zhM',
            },
            {
                id: 24,
                url: 'assets/marker/T6rWiDnpUrHOVkte.png',
                img: 'T6rWiDnpUrHOVkte',
                profile: 'T6rWiDnpUrHOVkte',
            },
            {
                id: 25,
                url: 'assets/marker/tB5yiCG5ikXi1AhN.png',
                img: 'tB5yiCG5ikXi1AhN',
                profile: 'tB5yiCG5ikXi1AhN',
            },
            {
                id: 26,
                url: 'assets/marker/tPWnMHRNZWjrJz4A.png',
                img: 'tPWnMHRNZWjrJz4A',
                profile: 'tPWnMHRNZWjrJz4A',
            },
            {
                id: 27,
                url: 'assets/marker/tyUmsbNzqCg4RLvC.png',
                img: 'tyUmsbNzqCg4RLvC',
                profile: 'tyUmsbNzqCg4RLvC',
            },
            {
                id: 28,
                url: 'assets/marker/uTMjMcPDp8RU5Rsu.png',
                img: 'uTMjMcPDp8RU5Rsu',
                profile: 'uTMjMcPDp8RU5Rsu',
            },
            {
                id: 29,
                url: 'assets/marker/vJax8stcRcLGw5Qe.png',
                img: 'vJax8stcRcLGw5Qe',
                profile: 'vJax8stcRcLGw5Qe',
            },
            {
                id: 30,
                url: 'assets/marker/W1NzxAwW3pLPqc65.png',
                img: 'W1NzxAwW3pLPqc65',
                profile: 'W1NzxAwW3pLPqc65',
            },
            {
                id: 31,
                url: 'assets/marker/y96KElOBPRZvQTOB.png',
                img: 'y96KElOBPRZvQTOB',
                profile: 'y96KElOBPRZvQTOB',
            },
            {
                id: 32,
                url: 'assets/marker/YAresMkhW51Ldxad.png',
                img: 'YAresMkhW51Ldxad',
                profile: 'YAresMkhW51Ldxad',
            },
            {
                id: 33,
                url: 'assets/marker/YvyYYHy4kq7LH4KV.png',
                img: 'YvyYYHy4kq7LH4KV',
                profile: 'YvyYYHy4kq7LH4KV',
            },
            {
                id: 34,
                url: 'assets/marker/ZRq1RfFDio5wR93G.png',
                img: 'ZRq1RfFDio5wR93G',
                profile: 'ZRq1RfFDio5wR93G',
            },
            {
                id: 35,
                url: 'assets/marker/d69D2PKc9dBy4jAG.png',
                img: 'd69D2PKc9dBy4jAG',
                profile: 'd69D2PKc9dBy4jAG',
            }
        ];
    }

    public static valueOf(profile: string): LayerUiModel {
        return this.get().find(it => it.profile === profile);
    }
}
